import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: "/home",
      meta: {level: "0"},
      component: Index,
      children: [
        {
          path: '/home',
          name: '首页',
          meta: {level: "1"},
          component: view => require(["@/pages/home/home.vue"], view)
        },
        {
          path: '/product',
          name: '产品介绍',
          meta: {level: "2"},
          redirect: "/product/advantage",
          component: view => require(["@/pages/product/product.vue"], view),
          children: [
            {
              path: 'advantage',
              name: '产品优势',
              meta: {level: "1"},
              component: view => require(["@/pages/product/children/advantage.vue"], view),
            },
            {
              path: 'ecology',
              name: '生态圈',
              meta: {level: "2"},
              component: view => require(["@/pages/product/children/ecology.vue"], view),
            },
            {
              path: 'total',
              name: '总体架构',
              meta: {level: "3"},
              component: view => require(["@/pages/product/children/total.vue"], view),
            },
            {
              path: 'four',
              name: '四大平台',
              meta: {level: "4"},
              component: view => require(["@/pages/product/children/four.vue"], view),
            },
            {
              path: 'open',
              name: '开放平台',
              meta: {level: "5"},
              component: view => require(["@/pages/product/children/open.vue"], view),
            },
            {
              path: 'technology',
              name: '技术架构',
              meta: {level: "6"},
              component: view => require(["@/pages/product/children/technology.vue"], view),
            },
            // {
            //   path: 'network',
            //   name: '网络架构',
            //   meta: {level: "6"},
            //   component: view => require(["@/pages/product/children/network.vue"], view),
            // },
            {
              path: 'process',
              name: '问诊流程',
              meta: {level: "7"},
              component: view => require(["@/pages/product/children/process.vue"], view),
            },
            {
              path: 'safety',
              name: '信息安全',
              meta: {level: "8"},
              component: view => require(["@/pages/product/children/safety.vue"], view),
            },
          ]
        },
        {
          path: '/about',
          name: '关于我们',
          meta: {level: "3"},
          component: view => require(["@/pages/about/about.vue"], view)
        },
        {
          path: '/case',
          name: '优秀案例',
          meta: {level: "4"},
          component: view => require(["@/pages/case/case.vue"], view)
        },
        {
          path: '/connect',
          name: '联系我们',
          meta: {level: "5"},
          component: view => require(["@/pages/connect/connect.vue"], view)
        },
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js